import axios from 'axios'
import { BUSCAR_AGENDAMENTO_VIAGEM } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarAgendamentoViagem (agendamnetoViagemId, empresaId) {

  const url = `${URL}/agendamento-viagem/${agendamnetoViagemId}/empresa/${empresaId}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_AGENDAMENTO_VIAGEM,
        payload: response

      })
  );
}
